import React from "react";

export default function RichTextDisplay({value, noTopMargin, css}) {
    const shadowRootRef = React.useRef(null);
    const styleRef = React.useRef(null);
    return (
        <div ref={(containerRef) => {
            if (!shadowRootRef.current) {
            shadowRootRef.current = containerRef.attachShadow({mode: 'open'});
            }
            if (shadowRootRef.current.innerHTML !== value) shadowRootRef.current.innerHTML = value;
            if (noTopMargin) {
                const firstParagraph = shadowRootRef.current.querySelector('p');
                if (firstParagraph) {
                    firstParagraph.style.marginTop = '0';
                }
            }
            if (!styleRef.current) {
                styleRef.current = document.createElement('style');
                shadowRootRef.current.appendChild(styleRef.current);
            }
            if (css !== styleRef.current.textContent) {
                styleRef.current.textContent = css;
            }
        }} />
    );
}
